/**
 * Contract types for the internal operations dashboard's read-only admin API.
 *
 * Defined once here and imported by both the orby admin API
 * (`domains/orby/src/admin`) and the dashboard frontend (`apps/ops-dashboard`)
 * so the wire shape is never hand-duplicated across the two sides.
 */
// ── Pipeline status ──────────────────────────────────────────────────────────
/** Empty/missing fact cursor head — large enough to trip freshness alerts, surfaced as STALE in the ops dashboard. */
export const STALE_FACT_SENTINEL_SECONDS = 9_999_999;
/** Empty snapshot table — same semantics as {@link STALE_FACT_SENTINEL_SECONDS}. */
export const STALE_SNAPSHOT_SENTINEL_SECONDS = 9_999_999;
// ── Monitoring ───────────────────────────────────────────────────────────────
export var MonitoringAlertState;
(function (MonitoringAlertState) {
    MonitoringAlertState["ENABLED"] = "enabled";
    MonitoringAlertState["DISABLED"] = "disabled";
})(MonitoringAlertState || (MonitoringAlertState = {}));
// ── Search ───────────────────────────────────────────────────────────────────
export var OpsSearchEntityKind;
(function (OpsSearchEntityKind) {
    OpsSearchEntityKind["TOKEN"] = "token";
    OpsSearchEntityKind["ACCOUNT"] = "account";
    OpsSearchEntityKind["MARKET"] = "market";
    OpsSearchEntityKind["INSTRUMENT"] = "instrument";
})(OpsSearchEntityKind || (OpsSearchEntityKind = {}));
